

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IOrder} from '@/models/IOrder';

@Component({})
export default class TrackingIdView extends Vue {
  @Prop({ required: true }) private order!: IOrder;
  private canEdit: boolean = false;
  private submitting: boolean = false;
  private show: boolean = false;
  private text = '';
  private trackingId: string | null = '';

  @Watch('order.id', { immediate: true })
  private onOrderChange() {
    this.trackingId = this.order.tracking_number_from_transport;
  }

  get is_fulfill() {
    return this.order?.fulfillment_status === 'fulfilled';
  }

  private async update() {
    this.submitting = true;
    //
    // try {
    //   if (!this.trackingId) {
    //     return;
    //   }
    //
    //   const result = await updateTrackingIdForOrder(this.order, this.trackingId);
    //   if (result) {
    //     this.text = 'Update Success';
    //     this.order.tracking_number_from_transport = this.trackingId;
    //   } else {
    //     this.text = 'Error';
    //   }
    //   this.show = true;
    // } finally {
    //   this.submitting = false;
    // }
  }
}
